import type { QueryKey } from '@tanstack/react-query';

export const WEB3_PREDICTIONS_QUERY_KEY = 'WEB3_PREDICTIONS_QUERY_KEY';

export const getQueryKey = (...args: QueryKey): QueryKey => {
  return [WEB3_PREDICTIONS_QUERY_KEY, ...args];
};
